app.directive('openTradeItem', [
    function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/directives/openTrade.html'
        }
    }]);